module.exports = __webpack_public_path__ + "static/img/khfw11.a8ee9f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw11.jpg
// module id = jOL2
// module chunks = 3